var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet"},[_c('page-title',[_vm._v("我的钱包")]),_vm._v(" "),_c('balance-view'),_vm._v(" "),_c('coupons-view'),_vm._v(" "),_c('redeem-codes-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }